import { Validator } from 'vee-validate'

// Strict alphanumeric (no spaces, no special chars)
Validator.extend('strictlyAlphanumeric', {
  getMessage: field => `${field} must contain only letters and numbers (no spaces or special characters).`,
  validate: value => /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]+$/.test(value)
})